export enum AccountTab {
  PROFILE = 'profile',
  /** Billing address. */
  BILLING = 'billing',
  PAYMENTS = 'payments',
  REFUNDS = 'refunds',
  PASSWORD = 'password',
  PREFERENCES = 'preferences',
  NOTIFICATIONS = 'notifications',
  TERMS = 'terms',
  DELETE_ACCOUNT = 'delete-account',
}
